import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "./Navbar.scss";
import { routes } from "../Sidebar/routes";
import Icon from "../Icon";
import {
  selectUsername,
  selectUserProfilePic,
} from "../../../store/Selectors/userprofileSelectors";

const Navbar = () => {
  const location = useLocation();
  const route = routes.find((x) => x.path === location.pathname);
  const { name, picture } = useSelector((state: any) => ({
    name: selectUsername(state),
    picture: selectUserProfilePic(state),
  }));

  const title =
    route?.name ||
    (location.pathname === "/complete-profile" ? "Complete Profile" : "Excel Accounts");

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <h1 className="topbar__title">{title}</h1>

        <div className="topbar__user">
          <span className="topbar__username">{name || "User"}</span>
          {picture ? (
            <img
              className="topbar__avatar"
              src={picture}
              alt="profile"
              referrerPolicy="no-referrer"
            />
          ) : (
            <span className="topbar__avatar topbar__avatar--fallback">
              <Icon name="user" size={18} />
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
